module.exports = __webpack_public_path__ + "media/icons/outdent-e61f76ea.svg";